import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { AccountsSmsAvailability, SmsAvailability } from '@models/superaccount/settings';
import { ListRatesProfile, RatesProfile, RatesProfileNew } from '@models/superaccount/rates-profile';
import { compare } from 'fast-json-patch';

@Injectable({
  providedIn: 'root'
})
export class SuperaccountService {
  private readonly baseUrl;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getSmsAvailability(idSubaccount): Observable<AccountsSmsAvailability> {
    return this.http.get<any>(this.baseUrl + 'superaccount/prepare-transfer-credits/' + idSubaccount).pipe(
      map(data => {
        const newData = {
          subAccount: [],
          superAccount: []
        } as AccountsSmsAvailability;

        if (data?.smsAvailabilitySubaccount) {
          for (const iterator of data.smsAvailabilitySubaccount.smsavailability) {
            const smsAvailability = {
              messageType: iterator.message_type.id_message_type,
              availability: iterator.availability,
              idNation: iterator.nation?.id_nation
            } as SmsAvailability;
            newData.subAccount.push(smsAvailability);
          }
        }

        if (data?.smsAvailabilitySuperaccount) {
          for (const iterator of data.smsAvailabilitySuperaccount.smsavailability) {
            const smsAvailability = {
              messageType: iterator.message_type.id_message_type,
              availability: iterator.availability,
              idNation: iterator.nation?.id_nation
            } as SmsAvailability;
            newData.superAccount.push(smsAvailability);
          }
        }
        return newData;
      })
    );
  }
  /*
   *  Call Service rate-profile
   *
   */

  getListRatesProfile(page?: number, size?: number, sortColumn?: string, sortDirection?: string): Observable<ListRatesProfile> {
    let queryParams = new HttpParams();
    if (page) {
      queryParams = queryParams.set('page', String(page));
    }
    if (size) {
      queryParams = queryParams.set('size', String(size));
    }
    if (sortColumn) {
      queryParams = queryParams.set('sortColumn', String(sortColumn));
    }
    if (sortDirection) {
      queryParams = queryParams.set('sortDirection', String(sortDirection));
    }

    return this.http
      .get<Response>(this.baseUrl + 'superaccount/rate-profile/list-rates', { params: queryParams })
      .pipe(map(data => ListRatesProfile.deserialize(data)));
  }

  loadRateProfile(idRateProfile): Observable<RatesProfile> {
    const url = 'superaccount/rate-profile/' + idRateProfile;
    return this.http.get<Response>(this.baseUrl + url).pipe(map(data => RatesProfile.deserialize(data)));
  }

  createRateProfile(rateProfileNew: RatesProfile) {
    const url = 'superaccount/rate-profile';
    return this.http.post(this.baseUrl + url, rateProfileNew);
  }

  editRateProfile(idRateProfile, rateProfileOld, rateProfileNew, pricePerMessage?) {
    const patchHeaders = new HttpHeaders().set('Content-type', 'application/json-patch+json');
    const patchData = compare(rateProfileOld, rateProfileNew);
    if (pricePerMessage) {
      patchData.push(pricePerMessage);
    }
    const url = 'superaccount/rate-profile/' + idRateProfile;
    return this.http.patch<Response>(this.baseUrl + url, patchData, { headers: patchHeaders });
  }

  deleteRateProfile(idRateProfile): Observable<any> {
    const options = { responseType: 'text' as 'json', body: {} };
    const url = 'superaccount/rate-profile/delete/' + idRateProfile;
    return this.http.delete<Response>(this.baseUrl + url, options);
  }

  loadRateProfileNew(idRateProfile): Observable<RatesProfileNew> {
    const url = 'superaccount/rate-profile/' + idRateProfile;
    return this.http.get<Response>(this.baseUrl + url).pipe(map(data => RatesProfileNew.deserialize(data)));
  }
  sortPricePerNation(Data, typeProperty, idNationProperty, nationUser) {
    let sorted = Data.sort(function(a, b) {
      if (a[typeProperty] === 'EE') {
        return 1;
      }
      if (b[typeProperty] === 'EE') {
        return -1;
      }
      if (!a[idNationProperty]) {
        return -1;
      } else if (a[idNationProperty] === nationUser && b[idNationProperty]) {
        return -1;
      }
      if (!b[idNationProperty]) {
        return 1;
      } else if (b[idNationProperty] === nationUser && a[idNationProperty]) {
        return 1;
      }
      if (a[idNationProperty] > b[idNationProperty]) {
        return 1;
      }
      if (a[idNationProperty] < b[idNationProperty]) {
        return -1;
      }
      return 0;
    });
    return sorted;
    // this.editForm.get('pricePerMessage').patchValue(sortedProducts3);
  }
}
